import style from './Legenda.module.css'

const Legenda = ({ values, isAtiva, isAutenticada }) => {
  if (!(isAutenticada && isAtiva) && values.tipoEventoCertidao.siglTipoEventoCertidao == "QUIT_COMPENSACAO") {
    let text = "";

    if (!isAutenticada) {
      text += "autenticada ";
      if (!isAtiva) text += " e ativa";
    } else if (!isAtiva) text += "ativa";

    return (
      <div className={style.labelInfoWarning}>
        <span className={style.spanInfoWarning}>Atenção: A certidão não está {text}</span>
      </div>
    );
  }
  return null;
}

export default Legenda;